import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.scss'
import 'styles/global.scss'
import {RouterProvider} from 'react-router-dom'
import { appRouter } from 'router'
import { RecoilRoot } from 'recoil'
import {isBridgeAvailable, setBridgeAvailable} from "./core/configs/bookmapBridge";

/* Redirect from URL/?add_journal to /home/dashboard?modal=add_journal
   Keep it or ask addon team to change URL for adding journal.
   It was added to addon before it was implemented here */
if (window.location.pathname === '/' && window.location.search.includes('add_journal')) {
  window.location.href = window.location.origin + '/home/dashboard?modal=add_journal'
}

// Record if browser doesn't mark itself as embedded
if (!window.location.search.includes('embedded=true')) {
    if (isBridgeAvailable() == null) {
        setBridgeAvailable(false)
    }
} else {
    setBridgeAvailable(true)
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
    <React.StrictMode>
        <RecoilRoot>
            <RouterProvider router={appRouter} />
        </RecoilRoot>
    </React.StrictMode>
)
